import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Observable, Subject, firstValueFrom, of } from 'rxjs';
import { User } from '../models/user';
import { TravelGuideLike } from '../models/travel-guide.models';
import { TravelGuidesService } from './travel-guides.service';

const TABLE = "travelGuideLikes";

@Injectable({
  providedIn: 'root'
})
export class TravelGuideLikesService {

  private isTravelGuideLikeProcessDone = new Subject<string>();
  public $isTravelGuideLikeProcessDone = this.isTravelGuideLikeProcessDone.asObservable();

  constructor(public fireStore: AngularFirestore,
    private travelGuidesService: TravelGuidesService) { }

  getLikesByUser(user: User): Observable<(TravelGuideLike)[]> {
    if (user && user.uid) {
      return this.fireStore.collection<TravelGuideLike>(TABLE, ref => ref
        .where('userId', '==', user.uid))
        .valueChanges({ idField: 'likeId' });
    } else {
      return of([]);
    }
  }

  SetLikedData(user: User, travelGuideId: string): void {
    const likeId = this.fireStore.createId();
    const likeRef: AngularFirestoreDocument<any> = this.fireStore.doc(
      `${TABLE}/${likeId}`
    );

    const likedData: TravelGuideLike = {
      likeId: likeId,
      userId: user.uid,
      travelGuideId: travelGuideId
    };

    likeRef.set(likedData, {
      merge: true,
    }).then(() => {
      this.getAmountOfLikesByTravelGuide(travelGuideId).then((likes: number) => {
        this.travelGuidesService.updatedTravelGuideLikesCount(travelGuideId, likes).then(() => {
          this.isTravelGuideLikeProcessDone.next(likeId);
        });
      })
    });
  }

  getAmountOfLikesByTravelGuide(travelGuideId: string): Promise<(number)> {
    return new Promise((resolve) => {
      this.fireStore.collection<TravelGuideLike>(TABLE, ref => ref.where('travelGuideId', '==', travelGuideId))
        .get().subscribe((query) => {
          let countVisits = query.size;
          resolve(countVisits);
        })
    })
  }

  removeLike(likeId, travelGuideId) {
    const itemDoc = this.fireStore.doc(
      `${TABLE}/${likeId}`
    );
    return itemDoc.delete().then(() => {
      console.log("visitLike - like removed");
      this.getAmountOfLikesByTravelGuide(travelGuideId).then((likes: number) => {
        this.travelGuidesService.updatedTravelGuideLikesCount(travelGuideId, likes).then(() => {
          this.isTravelGuideLikeProcessDone.next(likeId);
        });
      })
    });
  }

}
